module.exports = __webpack_public_path__ + "img/pen.4489df2f.png";